const roles = {
  OWNER: "OWNER",
  OPERATOR: "OPERATOR",
};

export default roles;
